import CoreArticleMetrics, { ArticleMetricsClassList, ArticleMetricsElements, ArticleMetricsSelectors, ArticleMetricsTexts } from "ui-theme/widgets/article-metrics/js/article-metrics";

import {
    ComponentInjector,
    Inject,
    I18N
} from '@atypon/ui-utils'


class Texts extends ArticleMetricsTexts {}
class ClassList extends ArticleMetricsClassList {}
class Selectors extends ArticleMetricsSelectors {}
class Elements extends ArticleMetricsElements {}

@ComponentInjector(Selectors, Elements, ClassList, Texts)
class ArticleMetrics extends CoreArticleMetrics {

    async initializeToolbarClass(): Promise < void> {
        if (this.domUtils.getElements(".toolbar-metric-container").length > 0) {
        const { default: ToolbarMetric } = await import('./toolbar-metric'); 
        this.domUtils.getElements(".toolbar-metric-container").forEach((item, index) => {
            UX.toolbarMetrics = new ToolbarMetric(item, index);
                UX.toolbarMetrics.initialize();
            });
        }
    }
}

export default ArticleMetrics;

export {
    Elements as ArticleMetricsElements,
    Selectors as ArticleMetricsSelectors,
    ClassList as ArticleMetricsClassList,
    Texts as ArticleMetricsTexts
}